module.exports = __webpack_public_path__ + "static/media/pub_restaurant_reopening.f79ab5b2.webp";